import { render, staticRenderFns } from "./litigationPlan.vue?vue&type=template&id=3b8ee12a&scoped=true&"
import script from "./litigationPlan.vue?vue&type=script&lang=tsx&"
export * from "./litigationPlan.vue?vue&type=script&lang=tsx&"
import style0 from "./litigationPlan.vue?vue&type=style&index=0&id=3b8ee12a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ee12a",
  null
  
)

export default component.exports